import axios from "@/config/axiosConfig";

export const getAvailableProductionTakaDetailByTakaNo = (takaNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { takaNo, customerId: auth?.user?.Customer_Id };

      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }

      return axios.get("/production-taka-tp/get-available-production-transaction-detail-by-taka-no", { params }).then((response) => {
          return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const saveProductionTakaTp = (data, productionTransId, isUpdate) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      
      return axios.post(
        "/production-taka-tp/save-tp",
        { data, productionTransId, isUpdate },
        {
            params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
            throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getAvailableProductionTakaListByItemId = (itemId, takaNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { itemId, takaNo, customerId: auth?.user?.Customer_Id };

      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }

      return axios.get("/production-taka-join/get-available-production-transactions-by-item-for-join", { params }).then((response) => {
          return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const saveProductionTakaJoin = (data, isUpdate) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      
      return axios.post(
        "/production-taka-join/save-join",
        { data, isUpdate },
        {
            params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            console.error(error);
            throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};